import { useEffect, useMemo, useState } from 'react';
import type { DeploymentRecord } from '@/services/deploymentService';
import { getPlanResult, onPlanResultsChange, requestPlanResults, type PlanInfo } from '@/utils/deployPlanStore';

export type { PlanInfo };

/**
 * What each finished plan-only run found, by deployment id. Pass only the plan
 * rows on screen: each is read from its log once and kept for the session.
 */
export function useDeployPlans(records: DeploymentRecord[]): Record<string, PlanInfo | undefined> {
  const [version, setVersion] = useState(0);
  const signature = records.map((r) => `${r.deploymentId}:${r.endedAt || ''}`).join(',');

  useEffect(() => onPlanResultsChange(() => setVersion((v) => v + 1)), []);

  useEffect(() => {
    if (records.length > 0) requestPlanResults(records);
  }, [signature]);

  return useMemo(() => {
    const byId: Record<string, PlanInfo | undefined> = {};
    for (const record of records) byId[record.deploymentId] = getPlanResult(record.deploymentId);
    return byId;
  }, [signature, version]);
}
